import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
import { styled, Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import Typography from '@mui/material/Typography'
import { ReactComponent as EditIcon } from '../../../icon/backoffice_edit.svg'

type EditProps = {
    data: any
    variant?: 'text' | 'outlined' | 'contained'
    size?: 'small' | 'medium' | 'large'
    onClick?: (data: any) => void
}
const EditAction = (props: EditProps) => {
    const { t } = useTranslation()
    const classes = useStyles()

    return (
        <Button
            variant={props.variant}
            size={props.size}
            onClick={() => props.onClick?.(props.data)}
            classes={{ root: classes.button }}
        >
            <IconEdit />
            <StyledTypo>{t('BUTTON.EDIT')}</StyledTypo>
        </Button>
    )
}

export default EditAction

const useStyles = makeStyles((theme: Theme) => ({
    button: {
        padding: '5px 0px !important',
    },
}))

const StyledTypo = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    marginLeft: '5px',
    fontWeight: 'bold',
    color: theme.palette.primary.dark,
}))

const IconEdit = styled(EditIcon)(({ theme }) => ({
    height: '14px',
    fill: theme.palette.primary.dark,
}))
